import React from "react";
import styled from "styled-components";
import { PlanIcon } from "../images/plan_icon";
import { TransparentButton } from "../../../../../components/transparent_button";
import { SofaIcon } from "../images/sofa_icon";
import { PaintIcon } from "../images/paint_icon";
import { IAsyncData } from "../../../../../core/models";
import { IApartment } from "../../data/entities";
import { theme } from "../../../../../../theme/variables";
import { useTranslation } from "react-i18next";
import { ApartmentCalculatorButton } from "./apartment_calculator_button";
import { MortgageCalculatorButton } from "./mortgage_calculator_button";

const OptionsRow = styled.div`
  margin-top: auto;
  padding: 0.75rem 0;
`;

export const FooterItem = styled.div`
  text-align: center;
  fill: white;
  display: flex;
  align-items: center;
  font-size: 0.9rem;

  &:hover {
    fill: ${theme.colors.orange};
    color: ${theme.colors.orange};
  }

  @media (max-width: 1100px) {
    text-align: left;
  }

  @media (max-width: 550px) {
    text-align: center;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem 1rem;
  padding: 0 0.75rem;
  justify-items: center;

  @media (max-width: 550px) {
    padding: 0 0.25rem;
  }
`;

export const FooterItemText = styled.span`
  margin-left: 8px;
  color: white;
`;

export const StyledTransparentButton = styled(TransparentButton)`
  justify-self: center;
`;

export const ApartmentPlanLink = styled.a`
  justify-self: center;
`;

interface IProps {
  apartmentDetailBranch: IAsyncData<IApartment>;
  // openInteriorDesignModal: () => any;
  // openAboutRepairModal: () => any;
}

export const ApartmentActions: React.FC<IProps> = ({
  apartmentDetailBranch,
  // openInteriorDesignModal,
  // openAboutRepairModal,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <OptionsRow>
      <Grid>
        <ApartmentPlanLink target="_blank" rel="noopener noreferrer" href={apartmentDetailBranch.data?.fileUrl}>
          <FooterItem>
            <PlanIcon />
            <FooterItemText>Mənzil planı</FooterItemText>
          </FooterItem>
        </ApartmentPlanLink>
        {/* <StyledTransparentButton onClick={openInteriorDesignModal}>
          <FooterItem>
            <SofaIcon />
            <FooterItemText>{t("apartment:actions.interiorExample")}</FooterItemText>
          </FooterItem>
        </StyledTransparentButton> */}
        {/* <StyledTransparentButton onClick={openAboutRepairModal}>
          <FooterItem>
            <PaintIcon />
            <FooterItemText>{t("apartment:actions.aboutRepair")}</FooterItemText>
          </FooterItem>
        </StyledTransparentButton> */}
        {/* <ApartmentCalculatorButton /> */}
        {/* <MortgageCalculatorButton /> */}
      </Grid>
    </OptionsRow>
  );
};
